import Main from "./components/Details";

function Details() {
    return <Main/>
};

export default Details